module.exports = __webpack_public_path__ + "static/media/CursedBoysandBrokenHeartsBookCover.e6c37655.jpg";